import * as React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";


const FilterLoader = () => {
	return (
		<div style={{ display: "flex", justifyContent: "space-around" }}>
			<MuiCircularProgress />
		</div>
	)
}



export default FilterLoader;